import styled from 'styled-components';
import { DEVICES, pickThemeColor, pickThemeFontStyles } from '@/theme';

export const StyledWrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 31rem;
  background-color: ${pickThemeColor('BG_SECONDARY')};
  border-left: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
`;

export const StyledText = styled.div`
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('14', '22')};
  white-space: pre-wrap;

  a {
    color: ${pickThemeColor('ORANGE_PRIMARY')};
    font-style: italic;
    margin-left: 0.25rem;
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('16', '26')};
  }
`;

export const StyledHideBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  gap: 0.5rem;
  ${pickThemeFontStyles('16', '26')};
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 1.5rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    flex-direction: row;
  }
`;

export const StyledPostsWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 0.625rem;
  overflow: hidden;
  width: fit-content;
  column-gap: 3rem;
`;

export const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    margin: 0 auto;
    padding: 1rem 0;
  }
`;

export const StyledTitle = styled.div`
  color: ${pickThemeColor('BLACK_PRIMARY')};
  ${pickThemeFontStyles('16', '26', 'SEMI_BOLD')};
  text-align: left;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('28', '32', 'SEMI_BOLD')};
  }
`;
